import { cn } from "@/lib/utils";

/**
 * The app's mark: the favicon, made from `assets/brand/icon.svg` by `pnpm icons`. An image
 * rather than inline SVG, because the drawing's ids would clash where the header shows it twice.
 */
export function LogoMark({ className }: { className?: string }) {
  return (
    <img src="/favicon.svg" alt="" draggable={false} className={cn("size-7 shrink-0", className)} />
  );
}

export function Logo({ className }: { className?: string }) {
  return (
    <span className={cn("flex items-center gap-2.5", className)}>
      <LogoMark />
      <span className="flex flex-col leading-none">
        <span className="text-[15px] font-semibold tracking-tight">Bimmertools</span>
        <span className="text-[11px] font-medium tracking-wide text-muted-foreground uppercase">
          Inventory
        </span>
      </span>
    </span>
  );
}
